import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MuiRTL } from 'lib/MuiRTL';

const getPartBackgroundColor = (status, isFull) => {
  if (status === 4) return 'white';
  if (status === 1) return isFull ? '#447DA8' : '#4396D5';
  if (status === 0) return isFull ? '#6C9B71' : '#7ABC81';
  if (status === 2 && isFull) return '#A85A5D';
  return 'white';
};

const PartsCounter = props => {
  const {
    isFull,
    status,
    cellCount,
    productCellCount,
    emptyCellCount,
    title,
    onClick,
  } = props;

  const bgcolor = getPartBackgroundColor(status, isFull);

  return (
    <Box
      sx={{
        width: '90px',
        height: '90px',
        borderRadius: '8px',
        backgroundColor: bgcolor,
        border: '1px solid',
        borderColor: bgcolor === 'white' ? '#cccccc7c' : bgcolor,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Typography
        fontSize={14}
        fontWeight="lighter"
        color="#0c0c0c"
        paddingTop="8px"
        marginBottom="12px"
      >
        {title}
      </Typography>
      <MuiRTL>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2px',
            gap: '2px',
            direction: 'rtl',
          }}
        >
          <CellCounterBox>{cellCount}</CellCounterBox>
          <CellCounterBox>{emptyCellCount}</CellCounterBox>
          <CellCounterBox>{productCellCount}</CellCounterBox>
        </Box>
      </MuiRTL>
    </Box>
  );
};

export default PartsCounter;

const CellCounterBox = styled(Box)({
  width: '20px',
  height: '20px',
  fontSize: '11px',
  fontWeight: 'regular',
  backgroundColor: '#fff',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingRight: '6px',
  paddingLeft: '6px',
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
});
